// extracted by mini-css-extract-plugin
export default {"root":"ynI4j0"};